import { createI18n } from 'vue-i18n';
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';

const SUPPORTED_LOCALES = ['pt', 'en', 'es'];

function getBrowserLocale() {
  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

  if (!navigatorLocale) {
    return 'pt';
  }

  const locale = navigatorLocale.trim().split(/-|_/)[0].toLowerCase();

  return SUPPORTED_LOCALES.includes(locale) ? locale : 'pt';
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: getBrowserLocale(),
  fallbackLocale: 'pt',
  messages: { pt, en, es },
});
